import React from 'react';
import { Phone, Search, Sparkles, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const HowItWorks = ({ city = null }) => {
  const steps = [
    {
      icon: Phone,
      title: "1. Contact Gratuit",
      description: `Appelez-moi ou contactez-moi sur WhatsApp pour une consultation gratuite${city ? ` depuis ${city}` : ''}. Disponible 24h/24 et 7j/7. Expliquez-moi votre situation en toute confidentialité.`,
      color: "from-green-500 to-green-700"
    },
    {
      icon: Search,
      title: "2. Analyse Voyance",
      description: "Grâce à mes dons de voyant médium, j'analyse votre situation en profondeur. Je détecte les blocages, obstacles et influences négatives qui vous empêchent d'être heureux(se).",
      color: "from-purple-500 to-purple-700"
    },
    {
      icon: Sparkles,
      title: "3. Rituel Personnalisé",
      description: "Je choisis et effectue le rituel traditionnel africain le plus adapté à votre cas. Mes rituels puissants agissent rapidement sur le plan spirituel pour débloquer votre situation.",
      color: "from-amber-500 to-amber-700"
    },
    {
      icon: CheckCircle2,
      title: "4. Résultats en 7 Jours",
      description: "Vous constatez les premiers résultats en 3 à 7 jours maximum. Retour de l'être aimé, messages, appels, réconciliation. Résultats garantis ou le travail continue gratuitement.",
      color: "from-red-500 to-red-700"
    }
  ];

  return (
    <section className="py-16 bg-zinc-950">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
              Comment Fonctionne Mon Service de Marabout{city ? ` à ${city}` : ''} ?
            </h2>
            <p className="text-base md:text-lg text-amber-100/70 max-w-3xl mx-auto">
              Un processus simple, efficace et garanti en 4 étapes pour transformer votre vie
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step) => {
              const IconComponent = step.icon;
              return (
                <Card 
                  key={step.title}
                  className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20"
                >
                  <CardContent className="p-6 text-center">
                    <div className={`w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center mx-auto mb-5 shadow-lg transform hover:scale-110 transition-transform duration-300`}>
                      <IconComponent size={32} className="text-white" />
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-amber-400 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-xs md:text-sm text-amber-100/70 leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="mt-12 bg-gradient-to-br from-amber-900/20 to-black border border-amber-600/40 rounded-2xl p-6 md:p-8">
            <h3 className="text-xl md:text-2xl font-bold text-amber-400 mb-4 text-center">
              ⚡ Garantie Satisfait ou Remboursé
            </h3>
            <p className="text-sm md:text-base text-amber-100/80 text-center leading-relaxed max-w-3xl mx-auto">
              Si vous ne constatez aucun résultat après 7 jours, je continue le travail gratuitement jusqu'à satisfaction complète. C'est ma garantie de sérieux et d'efficacité. Vous ne payez qu'après avoir vu les premiers résultats concrets.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
